<template>
	<div v-editable="blok" class="inline-block mr-1 mb-1">
		<component
			:is="isInternalLink ? AbsoluteInternalLink : 'a'"
			:href="blok.link.cached_url"
			:target="blok.link.target"
		>
			<NuxtImg
				provider="storyblok"
				:src="blok.image.filename"
				:alt="blok.image.alt || ''"
				loading="lazy"
			/>
		</component>
	</div>
</template>

<script setup lang="ts">
	import type {ImageWithLinkStoryblok} from '@/storyblok/types';

	interface Props {
		blok: ImageWithLinkStoryblok
	}

	const props = defineProps<Props>();

	const AbsoluteInternalLink = resolveComponent('AbsoluteInternalLink');
	const isInternalLink = computed(() => props.blok.link.linktype === 'story');
</script>
